import { getLocation } from "../services/actions/home.action";
import UserService from "../services/api/UserService";

const removeExtraUrlCharacters = (path) => path.split("/")[1];

export const handleRedirection = (
  myUserInfo,
  locationIdFromURL,
  navigationBlocked,
  navigate
) => {
  // Navigating while a Keycloak callback is pending destroys the login (MS2-T1485)
  if (UserService.hasPendingAuthCallback()) return;
  const isUserLoggedIn = UserService.isLoggedIn();
  const isPublicPortal = !locationIdFromURL;
  const realUserLocation = myUserInfo?.location;
  const isRetireesPath = window.location.pathname === '/retirees';
  const currentPath = window.location.pathname;
  const isGlobalPage = 
  currentPath === '/recipeslist' 
  || currentPath === '/articleslist' 
  || currentPath.startsWith('/recipeslist/') 
  || currentPath.startsWith('/articlelist /')
  || currentPath.startsWith('/retirees/');
  const shouldRedirect =
    isUserLoggedIn &&
    (realUserLocation !== locationIdFromURL || isPublicPortal) &&
    !isRetireesPath &&
    !isGlobalPage;

  if (shouldRedirect && !navigationBlocked) {
    navigate(`/${realUserLocation}`);
  }
};

export const handleLocationUpdate = (dispatch, userLocation) => {
  const isUserLoggedIn = UserService.isLoggedIn();
  let locationToRedirect = null;

  if (userLocation && isUserLoggedIn) {
    locationToRedirect = userLocation;
  } else {
    const locationFromURL = removeExtraUrlCharacters(window.location.pathname);

    locationToRedirect = locationFromURL;
  }

  // Don't try to fetch location data for retiree portal
  if (locationToRedirect === 'retirees') {
    return;
  }

  getLocation(dispatch, locationToRedirect);
};
